import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { getExpandedItems } from "../../utils/outbound-labels-utils";
import { StringListCell } from "../cells/string-list-cell";

const catalogEntry = fgColumnEntries.warehouseBins;

function sortBinNames(names: Iterable<string>): string[] {
  return Array.from(new Set(names)).sort((a, b) =>
    a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" }),
  );
}

export const WarehouseBinsColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => {
    const binNames = sortBinNames(
      row.lineItemPickability?.flatMap(
        (li) => li.bins?.map((bin) => bin.storageLocationName) ?? [],
      ) ?? [],
    );
    return <StringListCell displayName="bin" strings={binNames} />;
  },
  renderExpandedCell: ({ row, expansionIndex }) => {
    const lineItems = row.lineItemPickability;
    if (!lineItems || lineItems.length === 0) {
      return null;
    }
    const expandedItem = getExpandedItems(row)[expansionIndex];
    if (!expandedItem) {
      return null;
    }
    const item = lineItems.find(
      (li) => li.externalId === expandedItem.externalId,
    );
    if (!item) {
      return null;
    }

    const binNames = sortBinNames(
      item.bins?.map((bin) => bin.storageLocationName) ?? [],
    );
    return <StringListCell displayName="bin" strings={binNames} />;
  },
  width: catalogEntry.defaultWidth,
};
